import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { ThemedButton } from '../ThemedButton';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { useWizard } from '../../contexts/WizardContext';

const AdditionalInsured = () => {
  const { formData, updateFormData, nextStep } = useWizard();
  const { control, handleSubmit, watch, register } = useForm({
    defaultValues: {
      additional_insured_required: formData.additional_insured_required,
      additional_insured_details: formData.additional_insured_details,
    }
  });

  const additionalInsuredRequired = watch('additional_insured_required');

  const onSubmit = (data) => {
    updateFormData(data);
    nextStep();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
      <div>
        <Label className="text-base mb-3 block">Additional Insured</Label>
        <p className="text-sm text-slate-600 mb-4">
          Are there any additional insureds immediately needed?
        </p>
        <p className="text-sm text-slate-500 mb-4">
          Additional insured parties are entities or individuals (such as venues, municipalities, or sponsors) that need to be named on the policy.
        </p>
        
        <Controller
          name="additional_insured_required"
          control={control}
          render={({ field }) => (
            <RadioGroup
              onValueChange={(value) => field.onChange(value === 'true')}
              defaultValue={field.value ? 'true' : 'false'}
              className="mt-3"
            >
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="true" id="additional_yes" data-testid="additional-insured-yes" />
                <Label htmlFor="additional_yes" className="font-normal cursor-pointer">Yes</Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="false" id="additional_no" data-testid="additional-insured-no" />
                <Label htmlFor="additional_no" className="font-normal cursor-pointer">No</Label>
              </div>
            </RadioGroup>
          )}
        />
      </div>

      {additionalInsuredRequired && (
        <div>
          <Label htmlFor="additional_insured_details">Please provide details about the additional insured parties *</Label>
          <p className="text-sm text-slate-600 mt-1 mb-2">
            Include names, addresses, and the relationship to your organization.
          </p>
          <Textarea
            id="additional_insured_details"
            data-testid="additional-insured-details-textarea"
            {...register('additional_insured_details', { 
              required: additionalInsuredRequired ? 'Please provide additional insured details' : false 
            })}
            className="mt-1.5 min-h-[120px]"
            placeholder="Example: City Parks Department, 123 Main St, Anytown, CA - Required for facility usage..."
          />
        </div>
      )}

      <ThemedButton 
        type="submit"
        data-testid="additional-insured-next-btn"
        variant="wizard" size="full"
      >
        Next: Review & Submit
      </ThemedButton>
    </form>
  );
};

export default AdditionalInsured;